// src/AppWrapper.js
import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import App from './App';
import PaymentSuccess from './PaymentSuccess';
import Terms from './Terms';
import NotFound from './NotFound';
import WhatIsErc from './pages/WhatIsErc';
import HowToFind from './pages/HowToFind';
import SupportedModels from './pages/SupportedModels';
import Faq from './pages/Faq';
import Troubleshooting from './pages/Troubleshooting';
import PrivacyPolicy from './pages/PrivacyPolicy';
import Contact from './pages/Contact';

const LANGS = ['ja', 'mn', 'ur', 'ru'];

function AppWrapper() {
  return (
    <Router>
      <Routes>
        {/* English routes (no prefix) */}
        <Route path="/" element={<App language="en" />} />
        <Route path="/what-is-erc" element={<WhatIsErc language="en" />} />
        <Route path="/how-to-find-erc-code" element={<HowToFind language="en" />} />
        <Route path="/supported-models" element={<SupportedModels language="en" />} />
        <Route path="/faq" element={<Faq language="en" />} />
        <Route path="/troubleshooting" element={<Troubleshooting language="en" />} />
        <Route path="/payment-success" element={<PaymentSuccess language="en" />} />
        <Route path="/terms" element={<Terms language="en" />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy language="en" />} />
        <Route path="/contact" element={<Contact language="en" />} />

        {/* Language-prefixed routes */}
        {LANGS.map((lang) => (
          <React.Fragment key={lang}>
            <Route path={`/${lang}/`} element={<App language={lang} />} />
            <Route path={`/${lang}/what-is-erc`} element={<WhatIsErc language={lang} />} />
            <Route path={`/${lang}/how-to-find-erc-code`} element={<HowToFind language={lang} />} />
            <Route path={`/${lang}/supported-models`} element={<SupportedModels language={lang} />} />
            <Route path={`/${lang}/faq`} element={<Faq language={lang} />} />
            <Route path={`/${lang}/troubleshooting`} element={<Troubleshooting language={lang} />} />
            <Route path={`/${lang}/terms`} element={<Terms language={lang} />} />
            <Route path={`/${lang}/privacy-policy`} element={<PrivacyPolicy language={lang} />} />
            <Route path={`/${lang}/contact`} element={<Contact language={lang} />} />
          </React.Fragment>
        ))}

        {/* Catch-all route for 404 - MUST be last */}
        <Route path="*" element={<NotFound />} />
      </Routes>
    </Router>
  );
}

export default AppWrapper;
